import React, { useState, useEffect, useRef } from "react";
import "./HeaderNotification.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function HeaderNotification() {
  return (
    <div className='employee-header-notification'>
      <i className='fa-regular fa-bell'></i>
    </div>
  );
}

export default HeaderNotification;
